import { Badge } from '@ovComponents/2-component/badge/badge';
import { useTranslation } from 'react-i18next';
import type { OptimizerAuditV2Record } from '../../types/audit.types';
import {
  getRebalanceModeBadgeColor,
  getRebalanceModeLabelKey,
  resolveRebalanceModeForDisplay,
} from '../../utils/presentation/rebalanceModePresentation';

export type BulkRebalanceRebalanceModeBadgeProps = {
  audit?: OptimizerAuditV2Record | null;
  testId?: string;
};

export const BulkRebalanceRebalanceModeBadge = ({
  audit,
  testId = 'bulk-rebalance-rebalance-mode-badge',
}: BulkRebalanceRebalanceModeBadgeProps) => {
  const { t } = useTranslation(['bulkRebalance']);
  const mode = resolveRebalanceModeForDisplay(audit);

  if (!mode) {
    return null;
  }

  return (
    <Badge
      label={t(getRebalanceModeLabelKey(mode))}
      color={getRebalanceModeBadgeColor(mode)}
      testId={testId}
    />
  );
};
